import React, { useState, useEffect } from "react"

// material-ui
import { Card, Grid, Button, Switch, Dialog } from '@mui/material';

import { getAdminList, updateAdminStatus } from "services/adminServices";
import moment from "moment";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import AdminFilter from './adminFilter';
import { getUrlCourtCode } from "helper/Court";
import { roleOption } from "constant/constant";
import { useNavigate } from "react-router";
import { getUserId } from "helper/Admin";

const initFilter = {
    searchQuery: '',
    page: 0,
    limit: 20
}
const initDialog = {
    open: false,
    data: null,
    actionConfirm: null,
    actionCancel: null
}

function Admins({
    partnerId,
    merchantId,
    partnerCode
}) {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)
    const [filter, setFilter] = useState(initFilter)
    const [dialog, setDialog] = useState(initDialog)
    const [totalData, setTotalData] = useState(0)
    const navigate = useNavigate()

    useEffect(() => {
        loadData()
    }, [filter, partnerId])

    const loadData = async () => {
        setLoading(true)
        let { data, error } = await getAdminList({
            searchQuery: filter.searchQuery ? filter.searchQuery : "",
            merchantId: partnerId,
            page: filter.page,
            limit: filter.limit
        });
        setLoading(false)
        if (!data) { return; }
        setRows(data.listAdmin)
        setTotalData(data.totalAdmin)
    }

    const changeAdminStatus = async (isActive) => {
        let { data, error } = await updateAdminStatus({
            _id: dialog.data._id,
            isActive: isActive
        });
        if (!data) { return; }
        if (data) {
            setDialog(initDialog)
            loadData()
        }
    }

    const valueCustomator = (e) => {
        return ({
            username: <span className='span-link' onClick={() => {
                let url = ''
                if (partnerId) {
                    url = `/${getUrlCourtCode()}/merchants/admins/edit/${e._id}?partnerId=${partnerId}&partnerCode=${partnerCode}&merchantId=${merchantId}`
                } else {
                    url = `/${getUrlCourtCode()}/admins/edit/${e._id}`
                }
                navigate(url, { state: rows })

            }}>{e.username}</span>,
            name: <TCLabel>{e.name}</TCLabel>,
            role: <TCLabel>{e.role ? roleOption.find(value => value.value === e.role).label : '-'}</TCLabel>,
            phoneNumber: <TCLabel>{e.phoneNumber ? e.phoneNumber : '-'}</TCLabel>,
            createdDate: <TCLabel>{moment(e.createdDate).format('YYYY/MM/DD HH:mm:ss')}</TCLabel>,
            isActive: <Switch disabled={e._id == getUserId()} onClick={() => onChangeDialog({ open: true, data: e })} checked={e.isActive} />,
        })
    }

    const onChangeFilter = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }

    const onChangeDialog = (e) => {
        setDialog(prev => ({
            ...prev,
            ...e
        }))
    }

    return (
        <>
            <Grid container spacing={2} className="animated fadeIn">
                <Grid item xs={12} sm={4}>
                    <Button variant="contained" disableElevation onClick={() => {
                        let url = ''
                        if (partnerId) {
                            url = `/${getUrlCourtCode()}/merchants/admins/add?partnerId=${partnerId}&partnerCode=${partnerCode}&merchantId=${merchantId}`
                        } else {
                            url = `/${getUrlCourtCode()}/admins/add`
                        }
                        navigate(url, { state: rows })
                    }}>Create Admin</Button>
                </Grid>
                <Grid item xs={12} sm={8}>
                    {
                        !partnerId &&
                        <AdminFilter filter={filter} onChangeFilter={onChangeFilter} />
                    }
                </Grid>
            </Grid>
            <TableComponent
                columns={[
                    { label: "Username" },
                    { label: "Name" },
                    { label: "Role" },
                    { label: "Reg Phone Number" },
                    { label: "Created Date" },
                    { label: "Status" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                pageChange={(e) => {
                    onChangeFilter({ page: e })
                }}
                loading={loading}
                totalData={totalData}
                page={filter.page}
            />
            <Dialog open={dialog.open} onClose={() => setDialog(initDialog)}>
                {dialog && dialog.data &&
                    <Card>
                        <Grid p={2}>
                            <TCLabel bold={true}>{dialog.data.isActive ? `Set Admin ${dialog.data.username} as Inactive ?` : `Set Admin ${dialog.data.username} as Active ?`}</TCLabel>
                            <TCLabel style={{ marginTop: 10 }}>Name : {dialog.data.name}</TCLabel>
                            <TCLabel>Phone Number : {dialog.data.phoneNumber || "-"}</TCLabel>
                            <TCLabel>Role : {dialog.data.role ? roleOption.find(value => value.value === dialog.data.role).label :'-'}</TCLabel>
                        </Grid>
                        <Grid container xs={12} spacing={1} p={1} justifyContent={"right"}>
                            <Grid item>
                                <Button onClick={() => {
                                    setDialog(initDialog)
                                }}>Cancel</Button>
                            </Grid>
                            <Grid item>
                                <Button variant='contained' style={{ backgroundColor: '#0198E1' }} onClick={() => changeAdminStatus(!dialog.data.isActive)}>Confirm</Button>
                            </Grid>
                        </Grid>
                    </Card>
                }
            </Dialog>
        </>
    )
}

export default Admins